// Tracks whether the Space Cockpit app inside the persistent #sc-frame iframe
// (see SpaceCockpitAnchor in App.jsx) has signaled {ready: true}.
// Module-level because the iframe is a singleton that outlives the
// SpaceCockpitFrame components which mount and unmount per page — posting a
// scene before SC is ready would be lost inside a still-loading frame.
let scReady = false;

export const isSCReady = () => scReady;
export const setSCReady = (ready) => { scReady = ready; };
